import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["rioConfig", "headerDataSource"];
import React from 'react';
import { useEffect } from 'react';
import { breakpoints } from '@chegg-ui/theme';
import { initializeRioClient, updateAuthState } from '@chegg-me-components/utils';
import { ApolloProvider } from '@apollo/client';
import Media from 'react-media';
import HeaderShell from '../../shared/HeaderShell';
import { configureHeaderGQLServer } from '../../shared/configureHeaderGQLServer';
import DesktopHeaderContent from '../../shared/retrofit/desktop/DesktopHeaderContent';
import MobileHeaderContent from '../../shared/retrofit/mobile/MobileHeaderContent';
import useApolloClient from '../../shared/useApolloClient';
import useHeaderData from '../../shared/useHeaderData';
import { ResponsiveHeaderSearchContainer } from '../../styles';
import { ExplicitlyHideSearchBar } from '../../types';
export var HeaderPresentational = function HeaderPresentational(_ref) {
  var serverRenderAsMobile = _ref.serverRenderAsMobile,
      mainContentId = _ref.mainContentId,
      skipDataQuery = _ref.skipDataQuery,
      user = _ref.user,
      cartCount = _ref.cartCount,
      children = _ref.children,
      navType = _ref.navType,
      dataTest = _ref['data-test'],
      onClickSignOut = _ref.onClickSignOut,
      userCourses = _ref.userCourses,
      envUrl = _ref.envUrl,
      activeSubLink = _ref.activeSubLink;
  var isResponsiveHeaderSearch = children !== ExplicitlyHideSearchBar && !Object.keys(children.props).includes('serverRenderAsMobile');

  var _useHeaderData = useHeaderData(envUrl, user, cartCount, onClickSignOut, skipDataQuery, navType, userCourses, true // This flag is used to extract User Courses
  ),
      userData = _useHeaderData.userData,
      signOutUser = _useHeaderData.signOutUser,
      userDataLoading = _useHeaderData.userDataLoading;

  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(HeaderShell, {
    isResponsiveSearch: isResponsiveHeaderSearch,
    mainContentId: mainContentId,
    "data-test": dataTest
  }, /*#__PURE__*/React.createElement(Media // adding an extra 50px margin to avoid the text wrapping in case of space crunch. Ref - https://chegg.atlassian.net/browse/ME-11021
  , {
    query: {
      maxWidth: "".concat(parseInt(breakpoints.md.max) + 50, "px")
    },
    defaultMatches: !!serverRenderAsMobile
  }, function (matches) {
    return matches ? /*#__PURE__*/React.createElement(MobileHeaderContent, {
      navType: navType,
      user: user || (userData === null || userData === void 0 ? void 0 : userData.userProfile),
      userCourses: userCourses || (userData === null || userData === void 0 ? void 0 : userData.userCourses),
      cartCount: cartCount !== null && cartCount !== void 0 ? cartCount : userData === null || userData === void 0 ? void 0 : userData.cartCount,
      onClickSignOut: signOutUser,
      envUrl: envUrl,
      activeSubLink: activeSubLink,
      userDataLoading: userDataLoading
    }) : /*#__PURE__*/React.createElement(DesktopHeaderContent, {
      navType: navType,
      user: user || (userData === null || userData === void 0 ? void 0 : userData.userProfile),
      userCourses: userCourses || (userData === null || userData === void 0 ? void 0 : userData.userCourses),
      cartCount: cartCount !== null && cartCount !== void 0 ? cartCount : userData === null || userData === void 0 ? void 0 : userData.cartCount,
      onClickSignOut: signOutUser,
      envUrl: envUrl,
      activeSubLink: activeSubLink,
      userDataLoading: userDataLoading
    });
  })), isResponsiveHeaderSearch && /*#__PURE__*/React.createElement(ResponsiveHeaderSearchContainer, null, /*#__PURE__*/React.cloneElement(children, {
    pageLocation: children.props.pageLocation ? children.props.pageLocation : navType
  })));
};
HeaderPresentational.displayName = 'HeaderPresentational';

var Header = function Header(_ref2) {
  var rioConfig = _ref2.rioConfig,
      headerDataSource = _ref2.headerDataSource,
      passThoughProps = _objectWithoutProperties(_ref2, _excluded);

  useEffect(function () {
    // Initialize Rio Client
    if (rioConfig) {
      initializeRioClient(rioConfig);
    } // This function will update the rio-client state if user is logged in


    updateAuthState();
  }, []);

  var _useApolloClient = useApolloClient({
    headerDataSource: configureHeaderGQLServer(headerDataSource)
  }),
      client = _useApolloClient.client,
      existingClient = _useApolloClient.existingClient;

  return existingClient ? /*#__PURE__*/React.createElement(HeaderPresentational, passThoughProps) : /*#__PURE__*/React.createElement(ApolloProvider, {
    client: client
  }, /*#__PURE__*/React.createElement(HeaderPresentational, passThoughProps));
};

Header.displayName = 'Header';
export default Header;


//////////////////
// WEBPACK FOOTER
// ./node_modules/@chegg-me-components/header/dist/esm/variants/retrofit/Header.js
// module id = 5618
// module chunks = 11